import { useAppDispatch } from '../redux/hooks';
// import { settingsThunk } from '../redux/slices/settings-slice';
// import { QueryUtils } from '../utils/queryUtils';
// import { wizardThunk } from '../redux/slices/wizard-slice';

const useBootstrap = () => {
    const dispatch = useAppDispatch();

    const fetch = async () => {
        // await QueryUtils.prefetchQueries();
        // await Promise.all([
        //     dispatch(ecomsThunk()).unwrap(),
        // ]);
        // await dispatch(wizardThunk()).unwrap();
        // await dispatch(settingsThunk()).unwrap();
    };

    return { fetch };
};

export default useBootstrap;
